import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=2265043b&scoped=true&lang=pug&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=2265043b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265043b",
  null
  
)

/* custom blocks */
import block0 from "~/lang/user?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231205171632%2Fcomponents%2Fsite%2Fnav%2Fmobile.vue&lang=json"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/image.vue').default,SiteNavBusinesshours: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/site/nav/businesshours.vue').default,SiteNavAccessibility: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/site/nav/accessibility.vue').default,SiteNavUtil: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/site/nav/util.vue').default})
